import React, { useState, useContext } from "react";
import { languages } from "../../languages/languages";
import UserContext from "../../languages/UserContext";

import "./About.scss";
import { Wood, Brick, Metal } from "../../assets/Images.js";

const About = () => {
  const user = useContext(UserContext);

  const res = [
    { name: `${languages[user.lang].Mission}` },
    { name: `${languages[user.lang].Competence}` },
    { name: `${languages[user.lang].Experience}` },
  ];

  const images = [Wood, Brick, Metal];

  const [condition, setCondition] = useState(0);

  const buttons = res.map((data, idx) => (
    <span
      key={idx}
      className={`tab-item ${condition === idx ? "tab-item--selected" : ""}`}
      onClick={() => setCondition(idx)}
    >
      <div>{data.name}</div>
    </span>
  ));

  const contentVariables = ["Mission", "Competence", "Experience"];
  const missionContent = (
    <div className="mission-content">
      <div className="mission-wrap">
        <div className="content">
          <h3 className="tab-title">
            {languages[user.lang][`Our${contentVariables[condition]}`]}
          </h3>
          <p className="mission-header">
            {languages[user.lang][`Our${contentVariables[condition]}Header`]}
          </p>
          <p className="mission-text">
            {languages[user.lang][`Our${contentVariables[condition]}Text`]}
          </p>
        </div>
      </div>
      <div className="image-wrap">
        <img src={images[condition]} alt="roof-builder" className="image" />
      </div>
    </div>
  );

  return (
    <section className="mission" id="mission">
      <div className="mission-buttons">{buttons}</div>
      {missionContent}
    </section>
  );
};

export default About;
